import { render, staticRenderFns } from "./task.vue?vue&type=template&id=dd155f2a&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd155f2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd155f2a')) {
      api.createRecord('dd155f2a', component.options)
    } else {
      api.reload('dd155f2a', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=dd155f2a&scoped=true", function () {
      api.rerender('dd155f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activiti/task.vue"
export default component.exports